import {
  setIsArtemis,
  setAadhaarResponse, setBeneficiarySearchResponsePayerId, setBeneficiarySearchResponsePayerName,
  setDOA, setHealthBankUser, setHospActionId, setMemberSearchId,
  setAllowNextStage,
  setStarDisabledBenefMessage,
  setHyphenGroup,
} from './../../actions/newAdmissionAction';
import { select, takeEvery, put } from 'redux-saga/effects';
import moment from 'moment';
import { RootState } from '../..';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import { Payer } from '../../../shared/models/payer.model';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import SendRequest from '../../../shared/services/sendRequest.service';
import actionTypes from '../../types/newAdmissionTypes';
import {
  getLookUpFullDetail, prepareAttachment, prepareBillDetail,
  getTotalClaimAmount, prepareExtension, setMemberId, getValueFromID, prepareClassifications,
  checkEmptyObj, findKeyValuePair, getPayerLookUpDetail, replaceEmptyStringWithUndefined, alreadyUploadedDocs, checkIsLazyLoadingMaster,
  getPrimarySearchKey,
  getProductCode,
} from '../../../modules/crm/inPatient/service/crmUtils';
import { IClaimActionAdditionalParams, NewAdmissionState } from '../../models/newAdmissionModel';
import { isEmpty } from 'lodash';
import {
  ACKNOWLEDGEMENT_PDF_DOWNLOAD_SUCCESS_MESSAGE,
  CASHLESS_PDF_DOWNLOAD_SUCCESS_MESSAGE,
  CHECKLIST_PDF_DOWNLOAD_SUCCESS_MESSAGE,
  COMMON_ERROR, CSV_AMOUNT_INVALID, MIN_CLAIM_AMOUNT_MESSAGE, INITIATED_ON_PLATFORM, ROOM_RENT_WITH_ADDITIONAL_FIELD_WARNING,
  ZERO_AMOUNT_VALIDATION_MESSAGE,
} from '../../../shared/constants/commonConstants';
import {
  abhaConfirmOtpError,
  abhaConfirmOtpSuccess,
  abhaVerificationSentOtpFaulire,
  abhaVerificationSentOtpSuccess,
  fetchAbhVerificationMethodsFailure,
  fetchAbhVerificationMethodsSuccess,
  setExistingClaimError,
  setHidConfirmationMessage,
  setIsAbhaVerified,
  setIsMinimize,
  setBeneficiaryPopUpRequired,
} from '../../actions/newAdmissionAction';
import {
  actions,
  baseUrl,
  BENEFICIARY_SEARCH_OPTION,
  BILL_DETAIL_EMAIL, BILL_PACKAGE_NAME, DRAFT_KEYS, NHCX_PRODUCT_CODE_WHITELISTING_LIST, OTHER_ID,
} from '../../../shared/constants/crmConstants';
import { centeredNotification, replaceRsAndComma, success, trimEmails } from '../../../utils/utility';
import { LookUpState } from '../../models/lookUpModel';
import { setSinceYearDate } from '../../actions/claimDetailsAction';
import { PayerInitialState } from '../../models/payerListModel';
import { NHCXState } from '../../models/nhcxModel';
import { HospitalState } from '../../models/hospitalModel';

export function* beneficiarySearch({ payload: {
  benefDetail,
  updateBeneficiaryList,
  failedBeneficiarySearch,
} }: any): any {
  const appDetail = ApplicationDetail.instance;
  const sendRequest = SendRequest.instance;
  const payerDetail = yield select((state: RootState): Payer => state.payerList.payer);
  const { selectedInsurerId, selectedCorporateName, newAdmissionSearchValues, searchType } =
    yield select((state: RootState): any => state.newAdmission);
  const { memberName: policyMemberName } =
    yield select((state: RootState): NHCXState => state.nhcx);
  const isNHCXEnabledHospital = ApplicationDetail.instance.getIsNHCXEnabledProvider();
  let flagMember = false;
  if ((payerDetail?.shortName === 'SHAI' || payerDetail?.shortName === 'MD India')) {
    flagMember = true;
  }
  let corporateCheck = false;
  if (newAdmissionSearchValues?.iHave === 'Corporate Name') {
    corporateCheck = true;
  }

  const {
    memberId, patientName, employeeId, corporateName: policyHolderName, policyNumber: policyNo, policyType, policyName,
    dateOfAdmission, coiNumber, certificateNumber, insuranceCardNumber, productId,
    isNHCXEnabledProvider, healthId, dateOfBirth,
  } = benefDetail;
  const { formControlConfig }: any = yield select((state: RootState): PayerInitialState => state.payerList);
  const payerConfigValues = Object.values(formControlConfig);
  const disableCardsBenefPayer = payerConfigValues?.some((config: any): any => Boolean(config?.showProductName));
  const primarySearchKeyRequired = payerConfigValues?.some((config: any): boolean => Boolean(config?.primarySearchKeyRequired));
  let requestPayload: any = {
    payerId: payerDetail.id,
    isClaimCreationBlockedWithoutBenef: payerDetail?.isClaimCreationBlockedWithoutBenef,
    rohiniCode: appDetail.getRohiniCode(),
    insurerId: selectedInsurerId,
    policyType: payerDetail?.isRpaPayer ? policyType : undefined,
    primarySearchKey: primarySearchKeyRequired ? getPrimarySearchKey(searchType) : undefined,
  };

  if (isNHCXEnabledHospital) {
    if (isNHCXEnabledProvider) {
      requestPayload = {
        ...requestPayload, NHCXEnabledRoutingAPI: 'MEMBERSEARCH', 'isNHCXEnabledProvider': true,
        'isDirectFlow': false, healthId,
      };
    } else {
      requestPayload = { ...requestPayload, isDirectFlow: true, isNHCXMemberFlow: true };
    }
  }
  if (payerDetail?.isGovtScheme) {
    requestPayload = { ...requestPayload, memberId: employeeId.trim(), productCode: payerDetail?.productCode };
  } else if (memberId) {
    requestPayload = {
      ...requestPayload, memberId: memberId.trim(),
      memberName: isNHCXEnabledProvider ? policyMemberName : patientName ? patientName : (flagMember ? patientName?.trim() : undefined),
      policyType: policyType ? policyType : flagMember ? (employeeId || policyHolderName ? 'Corporate' : 'Individual') : undefined,
      employeeId: flagMember ? employeeId : undefined,
      policyHolderName: flagMember ? policyHolderName?.trim() : undefined,
      dateOfAdmission: dateOfAdmission ? dateOfAdmission : undefined,
      policyNo: policyNo?.trim(),
      productId,
    };
  } else if (employeeId) {
    requestPayload = {
      ...requestPayload,
      employeeId: employeeId?.trim(),
      policyHolderName: policyHolderName?.trim() || selectedCorporateName,
      memberName: patientName ? patientName : (flagMember ? patientName?.trim() : undefined),
      policyNo: policyNo?.trim(),
      policyType: policyType ? (flagMember ? 'Corporate' : policyType) : corporateCheck === true ? 'Group' : policyNo && flagMember ? 'Corporate' : undefined,
      policyName: policyName ? policyName : undefined,
      dateOfBirth : dateOfBirth || undefined,
    };
  } else if (policyNo) {
    requestPayload = {
      ...requestPayload, policyNo: policyNo?.trim(), memberName: patientName?.trim(),
      policyType: policyType ? policyType : flagMember ? policyHolderName ? 'Corporate' : 'Individual' : undefined,
      employeeId: flagMember ? employeeId : undefined,
      policyHolderName: flagMember ? policyHolderName?.trim() : undefined,
      certificateNumber: certificateNumber ? certificateNumber : undefined,
    };
  } else if (coiNumber) {
    requestPayload = {
      ...requestPayload,
      coiNumber,
    };
  } else if (certificateNumber) {
    requestPayload = {
      ...requestPayload,
      certificateNumber,
    };
  } else if (insuranceCardNumber) {
    requestPayload = {
      ...requestPayload,
      insuranceCardNumber,
    };
  }
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/Beneficiary`;
    const beneficiaryDetail = yield sendRequest.postBenef<any, any>(url, requestPayload, { isShowErrorInInterceptor: false });
    const { memberDetails, isSuccess, errorMessage, allowNextStage, isPopUpNeeded,
      showRetryMessage, memberSearchId, payerId, payerName, isARTEMIS } =
      beneficiaryDetail || {};
    if (isSuccess) {
      if (payerId !== 0 && payerId !== requestPayload.payerId) {
        yield put(setBeneficiarySearchResponsePayerName(payerName));
        yield put(setBeneficiarySearchResponsePayerId(payerId));
      }

      setMemberId(memberDetails, memberId);
      updateBeneficiaryList(memberDetails);
      yield put(setBeneficiaryPopUpRequired(isPopUpNeeded));
      if (memberDetails?.some((member: Record<string, any>): boolean => member?.policyNo?.includes('-'))) {
        yield put(setHyphenGroup(true));
      } else {
        yield put(setHyphenGroup(false));
      }
      if (allowNextStage?.toUpperCase() === 'NO' && disableCardsBenefPayer) {
        yield put(setAllowNextStage(false));
        yield put(setStarDisabledBenefMessage(errorMessage));
      }
    } else {
      yield put(setHyphenGroup(false));
      failedBeneficiarySearch(errorMessage, allowNextStage, showRetryMessage);
    }
    yield put(setMemberSearchId(memberSearchId));
    yield put(setIsArtemis(isARTEMIS));
  } catch (err: any) {
    failedBeneficiarySearch(err?.message, undefined, err?.response);
  }
}

export function* beneficiarySearchForHIS ({ HISBenefSearchPayload, HISBenefSuccess, failedHISBenefSearch}: any): Generator {
  const sendRequest = SendRequest.instance;
  const { formControlConfig }: any = yield select((state: RootState): PayerInitialState => state.payerList);
  const payerConfigValues = Object.values(formControlConfig);
  const disableCardsBenefPayer = payerConfigValues?.some((config: any): any => Boolean(config?.showProductName));
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}IntegrationSystem/HISPayerMemberSearch`;
    const HISBenefResponse: any = yield sendRequest.post<any, any>(url, (HISBenefSearchPayload));
    const { memberDetails, isSuccess, errorMessage, allowNextStage, isPopUpNeeded,
      memberSearchId, memberSearchRequest } =
      HISBenefResponse || {};
    if (isSuccess) {
      HISBenefSuccess(memberDetails, memberSearchRequest);
      yield put(setBeneficiaryPopUpRequired(isPopUpNeeded));
      if (memberDetails?.some((member: Record<string, any>): boolean => member?.policyNo?.includes('-'))) {
        yield put(setHyphenGroup(true));
      } else {
        yield put(setHyphenGroup(false));
      }
      if (allowNextStage?.toUpperCase() === 'NO' && disableCardsBenefPayer) {
        yield put(setAllowNextStage(false));
        yield put(setStarDisabledBenefMessage(errorMessage));
      }
    } else {
      yield put(setHyphenGroup(false));
      failedHISBenefSearch(errorMessage);
    }
    yield put(setMemberSearchId(memberSearchId));
  } catch (err: any) {
    failedHISBenefSearch(err?.message, undefined, err?.response);
  }
}

export function* submitAdmission({ form, isEdit, onSuccess, onError }: any): Generator {
  try {
    const appDetail = ApplicationDetail.instance;

    // ! GETTING DATA
    const {
      classificationArray, uploadedFiles, defaultTimeline: { remarks }, isManualSubmission: memberSearchFailed,
      additionalAdmissionInfo, billAmountArray, submitWarn, isDraftSelected, beneficiaryStatus, panCardNumber, nameAdhaarVerified,
      adhaarVerified, panNoVerified, dlVerified, voterIDVerified, panVerified, panVerificationRequired, isNewBornCase,
      memberSearchId, isDaycareCase, searchType, selectedBeneficiaryDetail, isBeneficiarySelected,
    }: any = yield select((state: RootState): NewAdmissionState => state.newAdmission);
    const isNHCXEnabledProvider = ApplicationDetail.instance.getIsNHCXEnabledProvider();
    const isOrionIntegrationEnabledProvider = ApplicationDetail.instance.getIsOrionIntegrationEnabled();

    let pltFromPayerLookUp = false;
    const {
      payerList: { payer, payer: { id: payerId, uniqueIdentifier, productCode,
        isOnMailPayer, isCorporatePayer, isRPAOutboundDisabledPayer, shortName, isRpaPayer, isDirectPayer, isInitialDischargeEnabledPayer,
        lazyLoadMasterTypes, isNHCXEnabledPayerProvider, isNHCXEnabledWithoutABHAPayer } },
      lookUp: { proposedLineOfTreatment, pastHistory },
      payerLookUp,
      newAdmission,
      admissionDetails,
      admissionDetails: { sinceYearDate, claimDetails: claimDetail },
      mailBox: { hospitalConfiguration },
      hospital: { selectedPatientDetail } = {} as any,
    }: any = yield select((state: RootState): RootState => state);

    if (payerLookUp[uniqueIdentifier]?.proposedLineOfTreatment?.length) {
      pltFromPayerLookUp = true;
    } // the PLT options are taken from payerlookup for these payers
    const {
      insurerName: insurerNameLookUp = [],
      roomType: roomTypeLookUp = [],
      documentType: documentTypeLookUp = [],
      procedure: procedureLookUp = [],
      diagnosis: diagnosisLookUp = [],
      automationProcedures: automationProceduresLookUp = [],
      providerRoomType: providerRoomTypeLookUp = [],
      administrationRoute: administrationRouteLookUp = [],
      doctorSpecialization: doctorSpecializationLookUp = [],
    } = payerLookUp[uniqueIdentifier] || {};

    const {
      memberGenderSex: genderSex, memberGenderSexRadio: genderRadio, dateOfBirth: dob,
      isRulesConfigured, policyEndDate, policyStartDate, urn, courierTrackId, courierProvider, switchClick, isEasyDischarge,
      productName, additional_fields,
    } =
      newAdmission?.selectedBeneficiaryDetail ||
      (
        isEmpty(admissionDetails?.claimDetails)
          ? newAdmission?.admissionFormVal?.customerDetail
          : admissionDetails?.claimDetails
      );
    const { userInfo }: any = yield select((state: RootState): any => state?.idCard);
    const { phrAddress, gender, yearOfBirth, monthOfBirth, dayOfBirth } = userInfo;
    const dateOfBirth = dob || ((yearOfBirth && monthOfBirth && dayOfBirth) ? `${yearOfBirth}-${monthOfBirth}-${dayOfBirth}` :
      newAdmission?.admissionFormVal?.customerDetail ? newAdmission?.admissionFormVal?.customerDetail?.dateOfBirth : undefined);
    const { diagnosisDynamicLookup, procedureDynamicLookup }: any = yield select((state: RootState): LookUpState => state.lookUp);
    const attachments = uploadedFiles.filter(({ existingRecord }: any): boolean => !existingRecord);
    const { formControlConfig }: any = yield select((state: RootState): PayerInitialState => state.payerList);
    const { selectedPolicyDetail }: any = yield select((state: RootState): NHCXState => state.nhcx);
    const { isHISClaim, hospitalSearchPatientDetails }: any = yield select((state: RootState): HospitalState => state.hospital);
    const memberNameMatchPercentage = newAdmission?.percentageNameMatch;
    const draftCaseUrn = newAdmission?.govtSchemeUrn;
    const payerConfigValues = Object.values(formControlConfig);
    const isPanRequired = payerConfigValues?.filter(({ type, hidden }: any): boolean => (type === 'PanCardFieldPresentBill' && !hidden));
    const isBillItemsNotRequired = Boolean(payerConfigValues?.filter(({ type, hidden }: any): boolean =>
      (type === 'billItemsNotRequired' && !hidden))?.length);
    const isMandatoryBillDetailFieldRequired = Boolean(payerConfigValues?.filter(({ mandatoryBillDetailFieldRequired,
      hidden }: any): boolean => (mandatoryBillDetailFieldRequired === 'true' && !hidden))?.length);
    const memberIdMandatoryForNhcxWithoutABHA = Boolean(payerConfigValues?.filter(({type , hidden}: any): boolean => (type === 'MANDATORY_FOR_NHCX_WITHOUT_ABHA' && !hidden))?.length);
    const isMinValidationRequired = payerConfigValues?.filter(({ type }: any): boolean => type === 'minValidtaionRequired');
    const minClaimedAmountValidtaionObject = isMinValidationRequired[0];
    const minClaimedAmountRequired = minClaimedAmountValidtaionObject?.['minClaimedAmount'];
    const collapsibleBillSection = payerConfigValues?.some(({ type, hidden }: any): boolean =>
      type === 'COLLAPSIBLE_BILL_SECTION' && !hidden) ?? false;
    const isArtemisPayer = payerConfigValues?.some(({ type }: any): boolean => type === 'ARTEMIS') || false;
        // ! FETCHING FORM DATA
    const {
      customerDetail, treatmentDetail, billDetail, otherFormDetail, healthId: healthIdAddr, abhaAddress,
      token,
    } = form;
    if (shortName === 'SHAI' || shortName === 'NIVA BUPA') {
      if (!billDetail?.Room_rent_Nursing_charges) {
        billDetail.Room_rent_Nursing_charges = treatmentDetail?.payerRoomType;
      }
    }
    customerDetail.corporateName = customerDetail?.corporateNameDropdown || customerDetail?.corporateName;
    if (customerDetail?.corporateNameDropdown) {
      const mappedValue = findKeyValuePair(payerLookUp[uniqueIdentifier]?.corporate_name,
        'value', customerDetail.corporateNameDropdown, true) || findKeyValuePair(payerLookUp[uniqueIdentifier]?.corporate_name,
          'name', customerDetail.corporateNameDropdown, true);
      customerDetail.corporateName = String(mappedValue?.payerMasterValue);
    }
    treatmentDetail.doctorQualification = treatmentDetail?.doctorQualificationDropDown || treatmentDetail?.doctorQualification;
    // for ICICI diagnosis and procedure pyload fix
    treatmentDetail.diagnosis = treatmentDetail?.diagnosis ? treatmentDetail?.diagnosis :
      Array.isArray(treatmentDetail?.diagnosisDropDown) ? treatmentDetail?.diagnosisDropDown : [treatmentDetail?.diagnosisDropDown];
    treatmentDetail.procedure = treatmentDetail?.procedure ? treatmentDetail?.procedure :
      Array.isArray(treatmentDetail?.procedureDropDown) ? treatmentDetail?.procedureDropDown : [treatmentDetail?.procedureDropDown];
    customerDetail.relation = customerDetail?.relation || customerDetail?.relationTextInput; // added this as respective to different payers
    const {
      fullName: patientName, mobile, emailId: email, policyNumber: policyNo, memberId, pehchanNo,
      corporateName: policyHolderName, insurerName, insurerNameText, employeeId, inPatientNumber: ipNumber,
      district, aadharNo, designation, relation, unitName, employeeName, placeOfPosting, healthId, hospitalNumber,
      retailOrCorporate, kycPan: kycpan, kycAdhaar, insuranceCardNumber, policyType, corporate_name, memberGenderSexRadio: patientGender,
      attendantContactNumber, voterId, drivingLicense,
      memberGenderSelect: genderSelect,
      certificateNumber, memberEmergencyContactPerson: emergencyContactPerson, familyPhysicianName,
      physicianMobileNumber, attendingRelativeMobile, mediclaimOthers, otherMediclaim, memberAge: patientAge, payer: payerName,
    } = customerDetail;
    const {
      diagnosis, procedure, diagnosisMandatory, proposedLineOfTreatment: procedureType, dateOfAdmission,
      dateOfDischarge, doctorName, doctorQualification, doctorMobileNo,
      payerRoomType, roomTypeText, hospitalRoomType, doctorRegNo: docRegNo, ailment,
      dialysis, isDeathCase = [null], automatedProcedure, routeOfAdministration, speciality, doctorSpecialization,
      presentComplaints, isMultipleSurgeries, pastHistoryOfPresentAilment, internalRemark, stateMedicalCouncilText,
      routeOfAdministrationText, stateMedicalCouncil, newPackageName,
      investigationDetails, hypertensionMonths, diabetesMonths, estimatedDays, ailmentDuration, anesthesiaType,
      dateOfExpiry, reasonForInjury, accidentDueTo, noOfAdoptedChildren, noOfDeliveries, noOfBiologicalChildren, sinceWhenDuration,
      sinceWhenPeriod, dateOfSurgery, cataractOperatedFor, surgeryType, hospitalizationReason,
      systemOfMedicine,
      subGroup,
      conditionOnDischarge,
      stayLength: [startDate, endDate] = [],
      dayCareType, reasonForEnhancement, reasonForReconsideration,
      treatmentType,

    } = treatmentDetail;
    // Extract bill-related fields dynamically from otherFormDetail and return an array of objects
    const billPackageNameMulti = Object?.keys(otherFormDetail || {})?.reduce((acc: any, key: any): any => {
      // Check if otherFormDetail[key] exists and is valid
      if (otherFormDetail[key]) {
        // Check if the key exists in BILL_DETAIL_EMAIL and get the corresponding bill detail object
        const billDetailItem = BILL_DETAIL_EMAIL?.find((detail: any): any => detail?.billPackageName === key);
        if (billDetailItem) {
          // Push the billDetailItem with the corresponding value from otherFormDetail into the array
          acc?.push({
            ...billDetailItem, // Include the entire bill detail item
            billAmount: typeof otherFormDetail[key] === 'number'
              ? otherFormDetail[key]
              : typeof otherFormDetail[key] === 'string'
                ? Number(otherFormDetail[key].replace(/[^0-9.]/g, '')) || 0
                : 0,
            // Retain the value from otherFormDetail, handle null/undefined safely
          });
        }
      }
      return acc;
    }, []);
    const {
      fullName: patientNameMulti, memberId: memberIdMulti, policyNumber: policyNoMulti,
      procedure: procedureMulti,
      claimedAmount: claimedAmountMulti, additionalEmails, mobile: mobileMulti, inPatientNumber: inPatientMulti,
      memberAge: patientAgeMulti, diagnosis: diagnosisMulti,
      doctorName: doctorNameMulti, corporateName: policyHolderNameMulti, payerRoomType: payerRoomTypeMulti,
      doctorRegNo: docRegNoMulti, proposedLineOfTreatment: procedureTypeMulti, employeeId: employeeIdMulti, emailId: emailMulti,
      stayLength: [startDateMulti, endDateMulti] = [], dayCareType: dayCareTypeMulti,
    } = otherFormDetail || {};
    const trimmedEmails = trimEmails(additionalEmails);
    let otherMemberDetail = {
      district, aadharNo, designation, relation, unitName, employeeName, placeOfPosting, urn,
      corporate_name, draftCaseUrn,
    };
    const {
      selectedPackage,
      selectedDraft,
      isCovidCase,
      dateOfDiagnosis,
      sinceFeverDays,
      oxygenSaturationLevel,
      respiratoryRate,
      draftValue,
      diagnosisSelectedValues,
      isArtemis,
    } = newAdmission;
    let action: any = (appDetail.getIsInitialDischargeEnabledProvider() && isDaycareCase && isInitialDischargeEnabledPayer) ? 'INITIALDISCHARGE' : 'NEWADMISSION';
    let payerClaimNo = null;
    let hospActionId = null;
    let finalDoctorSpecialization;
    let isNHCXClaimFlow = false;
    let isNHCXClaimFlowEdit = false;
    let isArtemisClaim = false;

    if (isEdit) {
      const { nextAllowStatus, payerClaimNo: claimNumber, hospActionId: hospitalActionId,
        isNHCXClaimFlow: isNHCXClaimFlowFromClaim, isArtemis: isArtemisFlowClaim,
      }: any = yield select((state: RootState): any => state.admissionDetails.claimDetails);
      if (nextAllowStatus?.length) {
        [action] = nextAllowStatus;
        payerClaimNo = claimNumber;
        hospActionId = hospitalActionId;
      } else {
        action = null;
      }
      if (isNHCXEnabledProvider) {
        isNHCXClaimFlowEdit = isNHCXClaimFlowFromClaim;
      }
      isArtemisClaim = isArtemisFlowClaim;
    } else if (isDraftSelected) {
      const { claimDetails } = admissionDetails;
      action = (appDetail.getIsInitialDischargeEnabledProvider() && isDaycareCase && isInitialDischargeEnabledPayer) ?
        'INITIALDISCHARGE' : claimDetails?.nextAllowStatus?.[0] || 'NEWADMISSION';
      hospActionId = claimDetails?.hospActionId;
      payerClaimNo = claimDetails?.payerClaimNo;
    }
    const isPolicySelected = !isEmpty(selectedPolicyDetail) && Boolean(selectedPolicyDetail?.abhaNo) &&
     selectedPolicyDetail?.nhcxEnabledPayerForProvider;
    const isNHCXPayerProvider = isNHCXEnabledProvider && isNHCXEnabledPayerProvider;
    const isHDFCWithWhitelistedProduct = shortName === 'HDFC' &&
      NHCX_PRODUCT_CODE_WHITELISTING_LIST.includes(selectedPolicyDetail?.productCode);

    const checkIsValidPolicy = (isPolicySelected && (isHDFCWithWhitelistedProduct || shortName !== 'HDFC')) ;

    const memberIdMandatoryValidation = (searchType === BENEFICIARY_SEARCH_OPTION[0] && !isEmpty(selectedBeneficiaryDetail));
    // check if beneficiary search is successfull and member id search

    const checkIsNHCXClaim = (isNHCXTobeConsidered: boolean, isEditFlow: boolean, isDraftClaim: boolean,
      nhcxWithoutABHA: boolean): boolean => {
      if (!isNHCXTobeConsidered) {
        return false;
      } else if (isEditFlow) {
        return isNHCXClaimFlowEdit;
      } else if (isDraftClaim) {
        if (draftValue === DRAFT_KEYS.newAdmission) {
          // For new admission drafts if NHCX is enabled without ABHA and for payer(here MA) where member ID validation is required we check
          // We check if the beneficiary search is successful through the member ID search
          // For other payers no such check is required
          return nhcxWithoutABHA ? memberIdMandatoryForNhcxWithoutABHA ?
            memberIdMandatoryValidation : nhcxWithoutABHA : checkIsValidPolicy;
        }
        return admissionDetails?.claimDetails?.isNHCXClaimFlow || false;
      } else {
          // If NHCX is enabled without ABHA and for payer (here MA)where member ID validation is required we check
          // We check if the beneficiary search is successful through the member ID search
          // For other payers no such check is required
        return nhcxWithoutABHA ? memberIdMandatoryForNhcxWithoutABHA ?
          memberIdMandatoryValidation : nhcxWithoutABHA : checkIsValidPolicy;
      }
    };

  isNHCXClaimFlow = checkIsNHCXClaim(isNHCXPayerProvider , isEdit, isDraftSelected, isNHCXEnabledWithoutABHAPayer);

    if (hospitalConfiguration?.passwordExpire && (isOnMailPayer || isCorporatePayer)) {
      return onError('PASSWORD_EXPIRED');
    }
    if (moment(startDate)?.isAfter(moment(endDate))) {
      return onError('Please select the admission date less than the discharge date.');
    }
    if ((policyStartDate && policyEndDate) && (moment(startDate)?.isAfter(moment(policyEndDate).add(2, 'day')) ||
      moment(policyStartDate)?.isAfter(moment(startDate)))) {
      return onError('Please select admission date after policy start date and before policy end date.');
    }

    if (!attachments?.length && action !== 'EDIT') {
      yield put(setIsMinimize(false));
      return onError('NA');
    }

    const readyBillDetail = prepareBillDetail(billDetail, selectedPackage, dialysis, dateOfAdmission, dateOfDischarge, payer,
       collapsibleBillSection);
    if (readyBillDetail.length === 1 && readyBillDetail[0].billPackageName === BILL_PACKAGE_NAME()[1]) {
      return onError(ROOM_RENT_WITH_ADDITIONAL_FIELD_WARNING);
    }
    const checkIfPOIEnabled = (): boolean => (appDetail.getIsPOIEnabledForHospital());

    if (process.env.REACT_APP_IS_PAN_CARD_DETAILS_ENABLED === 'true' && checkIfPOIEnabled() && isPanRequired && panVerificationRequired) {
      if (panVerificationRequired && !panVerified) { // to prevent submission if panverification is required and not verified
        return onError('Please verify PAN for submission');
      }
    }

    if (isBillItemsNotRequired && selectedPackage?.length === 0) { // To prevent submission for Yeshasvini scheme without package selection
      return onError('Please Select a Package for Claim Submission');
    }

    const roomRentFieldFilled = readyBillDetail?.some((bill: any): any => bill?.billLevel3CategoryCode === '101003');

    if (isMandatoryBillDetailFieldRequired && readyBillDetail?.length > 0 && !roomRentFieldFilled) {
      // To prevent submission unless room rent is filled for ICICI
      return onError('Please enter Room Rent Charges in Bill Details for Claim Submission');
    }
    const claimedAmount = readyBillDetail?.length > 0 ? getTotalClaimAmount(readyBillDetail) :
      collapsibleBillSection ?
      parseInt(replaceRsAndComma(billDetail.claimedAmount), 10) :
      typeof claimedAmountMulti === 'number' ? claimedAmountMulti :
      parseInt(replaceRsAndComma(claimedAmountMulti), 10) || 0;

    if (Number(claimedAmount) <= 0) {
      return onError(ZERO_AMOUNT_VALIDATION_MESSAGE);
    }

    if (isMinValidationRequired && claimedAmount <= minClaimedAmountRequired) {
      return onError(MIN_CLAIM_AMOUNT_MESSAGE.concat(minClaimedAmountRequired.toString()));
    }

    const grossAmountfromCSV = billAmountArray.reduce((total: number, { finalAmount }: any): number => total + parseFloat(finalAmount), 0);
    if (!submitWarn &&
      (billAmountArray.length > 0) &&
      ((Number(claimedAmount - grossAmountfromCSV) >= 10)
        || (Number(grossAmountfromCSV - claimedAmount) >= 10))) {
      return onError(CSV_AMOUNT_INVALID);
    }
    // ! REQ DTO CREATION
    const ailmetPastHistory = payerLookUp[uniqueIdentifier]?.pastHistory?.length > 0
      ? getPayerLookUpDetail(ailment, payerLookUp[uniqueIdentifier]?.pastHistory) :
      getLookUpFullDetail(ailment, pastHistory, true); // condition to get pastHistory from payerLookUp or lookup varying by payer
    const updatedDropdown = {
      district: getValueFromID(district, payerLookUp[uniqueIdentifier]?.district || [], 'payerMasterId'),
      designation: getValueFromID(designation, payerLookUp[uniqueIdentifier]?.designation || []),
      relation: getValueFromID(relation, payerLookUp[uniqueIdentifier]?.relation || []),
    };
    otherMemberDetail = { ...otherMemberDetail, ...updatedDropdown };

    const autoProcedureArr: any = (automatedProcedure && automatedProcedure !== OTHER_ID) ?
      getLookUpFullDetail([automatedProcedure], automationProceduresLookUp, true) : undefined;

    const ProcdureDescAutomation: any = autoProcedureArr
      ?.map(({ maMappedProcedure, procedure: pcdr }: any): any => maMappedProcedure || pcdr) || [];
    let finalRoomType; let finalHospitalRoomType;

    // TODO: Update room type selection logic
    if (payerRoomType || payerRoomTypeMulti || roomTypeText) {
      finalRoomType = getLookUpFullDetail([payerRoomType || payerRoomTypeMulti || roomTypeText], roomTypeLookUp, true);
    } else if (hospitalRoomType && !(hospitalRoomType?.includes(OTHER_ID))) {
      const selectedProviderRoomType = getLookUpFullDetail([hospitalRoomType], providerRoomTypeLookUp, true, true)
        ?.filter((ele: any): boolean => ele);
      if (selectedProviderRoomType?.length) {
        finalHospitalRoomType = selectedProviderRoomType;
      }
    }

    let finalRemark;
    if (!checkEmptyObj(remarks)) {
      finalRemark = Object.values(remarks || {}).filter((msg: any): boolean => msg).join(', ');
    }
    if (doctorSpecialization) {
      const mappedDoctorSpecialization = getLookUpFullDetail([doctorSpecialization], doctorSpecializationLookUp, true);
      finalDoctorSpecialization = mappedDoctorSpecialization.length ? mappedDoctorSpecialization[0] : {};
    } else {
      finalDoctorSpecialization = admissionDetails?.claimDetails?.doctorSpecialization;
    }

    const diagnosisInfo = (diagnosis || diagnosisMandatory || diagnosisMulti) ?
      ((diagnosisMandatory === 'Other' || automatedProcedure) ? diagnosis : isOnMailPayer ? diagnosisMulti : [diagnosisMandatory]) :
      undefined;
    const finalDiagnosis = (shortName === 'HDFC' && process.env.REACT_APP_HDFC_FEATURES === 'true')
      || checkIsLazyLoadingMaster('Diagnosis', lazyLoadMasterTypes) ? (getLookUpFullDetail(diagnosisInfo, diagnosisDynamicLookup, true)
      || getLookUpFullDetail(diagnosisInfo, diagnosisSelectedValues, true)) : getLookUpFullDetail(diagnosisInfo, diagnosisLookUp, true);

    const [{ payerMasterValue: administrationRoute = null }]: any =
      getLookUpFullDetail([routeOfAdministration], administrationRouteLookUp, true);
    let finalSpecialityType;
    finalSpecialityType = getValueFromID(speciality, payerLookUp[uniqueIdentifier]?.speciality || []);

    const dynamicQuestionFields: any = yield select((state: RootState): any =>
      state.newAdmission.dynamicQuestionFields);
    const dynamicFields = dynamicQuestionFields?.map((ele: any): any => ele?.key);
    const findProcedureType = (): any => {
      if (procedureType || procedureTypeMulti) {
        let payerLookUpDetail = pltFromPayerLookUp ? getPayerLookUpDetail(Array.isArray(procedureType || procedureTypeMulti) ?
          (procedureType || procedureTypeMulti) :
          [procedureType || procedureTypeMulti], payerLookUp[uniqueIdentifier]['proposedLineOfTreatment']) : [];
        payerLookUpDetail = payerLookUpDetail?.length && payerLookUpDetail?.[0] !== undefined ? payerLookUpDetail : [];
        const lookUpDetail = getLookUpFullDetail(Array.isArray(procedureType) ?
          procedureType : [procedureType], proposedLineOfTreatment, true);
        return (payerLookUpDetail.length > 0 ? payerLookUpDetail : lookUpDetail.length > 0 ? lookUpDetail : []);
      } else {
        return undefined;
      }
    };

    const rpaStatus = isRpaPayer && !isRPAOutboundDisabledPayer ? INITIATED_ON_PLATFORM : '';
    const uhid = selectedPatientDetail?.patientDetails?.registrationNumber;
    const visitCode = selectedPatientDetail?.patientDetails?.visitCode;
    const visitType = selectedPatientDetail?.patientDetails?.visitType;
    const hospitalId = selectedPatientDetail?.hospitalId;  // HIS hospital ID
    const patientHISReferenceNumber = selectedPatientDetail?.patientHISReferenceNumber ? selectedPatientDetail?.patientHISReferenceNumber :
    hospitalSearchPatientDetails?.[0]?.patientHISReferenceNumber;
    const isDischargeContestCTA = admissionDetails?.claimDetails?.isDischargeContestCTA;
    const isOrionIntegrationEnabledPayerProvider = isOrionIntegrationEnabledProvider && isArtemisPayer;
    const isArtemisFlow = isArtemis || isArtemisClaim;
    const payerExtension = prepareExtension(
      {
        treatmentDetail,
        otherFormDetail,
        isRulesConfigured,
        ailmetPastHistory,
        policyStartDate,
        policyEndDate,
        roomType: finalRoomType,
        hospitalRoomType: finalHospitalRoomType,
        otherMemberDetail,
        isDeathCase: isDeathCase[0] === 'Yes' ? true : null,
        isDischargeCase: newAdmission?.admissionFormVal?.treatmentDetail?.isDischargeCase?.[0] === 'Yes' ? true : false,
        isCovidCase,
        sinceYearDate,
        dateOfDiagnosis: moment(dateOfDiagnosis)?.format(),
        sinceFeverDays,
        oxygenSaturationLevel,
        respiratoryRate,
        isMultipleSurgeries: isMultipleSurgeries === 'Multiple' ? true : false,
        speciality: finalSpecialityType,
        doctorMobileNo,
        doctorQualification,
        doctorSpecialization: finalDoctorSpecialization,
        beneficiaryStatus,
        memberSearchFailed : isDraftSelected ? !isBeneficiarySelected : memberSearchFailed,
        remarks,
        internalRemark,
        stateMedicalCouncil: stateMedicalCouncil || stateMedicalCouncilText,
        newPackageName: newPackageName || '',
        ProcdureDescAutomation: ProcdureDescAutomation.length ? ProcdureDescAutomation : undefined,
        additionalAdmissionInfo,
        hospitalNumber,
        pehchanNo,
        insuranceCardNumber,
        policyType,
        courierTrackId,
        switchClick,
        courierProvider,
        dateOfBirth,
        additionalEmails : trimmedEmails,
        action,
        routeOfAdministration: administrationRoute || routeOfAdministrationText,
        presentComplaints,
        pastHistoryOfPresentAilment,
        retailOrCorporate,
        kycpan,
        kycAdhaar,
        drivingLicense,
        voterId,
        dynamicFields,
        panCardNumber,
        attendantContactNumber,
        nameMatch: nameAdhaarVerified,
        idVerified: adhaarVerified || panNoVerified || dlVerified || voterIDVerified,
        familyPhysicianName,
        physicianMobileNumber,
        attendingRelativeMobile,
        mediclaimOthers,
        otherMediclaim,
        investigationDetails,
        hypertensionMonths,
        diabetesMonths,
        estimatedDays,
        ailmentDuration,
        anesthesiaType,
        certificateNumber,
        emergencyContactPerson,
        isEasyDischarge,
        hospitalizationReason,
        systemOfMedicine,
        subGroup,
        conditionOnDischarge,
        accidentDueTo,
        dateOfExpiry,
        reasonForInjury,
        sinceWhenPeriod,
        sinceWhenDuration,
        noOfBiologicalChildren,
        noOfAdoptedChildren,
        noOfDeliveries,
        dateOfSurgery,
        cataractOperatedFor,
        surgeryType,
        isNHCXClaimFlow,
        isNewBornCase,
        memberSearchId,
        memberNameMatchPercentage,
        insurerName: (insurerName || insurerNameText) ?
          getLookUpFullDetail([insurerName || insurerNameText], insurerNameLookUp, true)?.[0]?.payerMasterValue :
          undefined,
        payerName,
        rpaStatus,
        uhid,
        visitCode,
        visitType,
        draftId: selectedDraft?.draftId,
        hospitalId,
        isDirectPayer: isDirectPayer ? isDirectPayer : undefined, // adding isDirectPayer flag in extensions to decide if its a email or
        // Direct payer for that provider
        patientHISReferenceNumber,
        isArtemis: isArtemisFlow ? isArtemisFlow : undefined,
        searchType,
        productName,
        policySource : additional_fields?.policySource,
        selectedPackage,
        claimDetails: claimDetail,
        isDischargeContest: isDischargeContestCTA,
        dayCareType: (dayCareTypeMulti || dayCareType),
        reasonForEnhancement,
        reasonForReconsideration,
        isOrionIntegrationEnabled : isOrionIntegrationEnabledPayerProvider,
        treatmentType,
        payerProductCode : getProductCode(isOrionIntegrationEnabledPayerProvider, isArtemisFlow),
      },
    );
    // ! FINAL DTO
    const requestPayload = {
      action,
      hospActionId,
      payerClaimNo,
      patientAge: isNaN(parseInt(patientAge || patientAgeMulti, 10)) ? undefined : parseInt(patientAge || patientAgeMulti, 10),
      patientGender: (genderSex || genderRadio || genderSelect || patientGender),
      patientName: patientName || patientNameMulti,
      policyHolderName: policyHolderName || policyHolderNameMulti,
      employeeId: employeeId || employeeIdMulti,
      retailOrCorporate,
      kycAdhaar,
      kycpan,
      voterId,
      drivingLicense,
      policyNo: policyNo || policyNoMulti,
      doa: moment(isOnMailPayer || isRPAOutboundDisabledPayer ? startDateMulti : startDate)?.format(), // Bugfix-PPT-536
      dod: moment(isOnMailPayer || isRPAOutboundDisabledPayer ? endDateMulti : endDate)?.format(),
      memberId: !isNewBornCase ? memberId || memberIdMulti : null,
      employeeName,
      InPatientNo: ipNumber || inPatientMulti,
      doctorName: doctorName || doctorNameMulti,
      docRegNo: docRegNo || docRegNoMulti,
      ipNumber,
      hospitalNumber,
      insuranceCardNumber,
      policyType,
      isCovidCase,
      mobileNo: (mobile || mobileMulti)?.substr(4)?.split(' ')?.join(''),
      email: email || emailMulti,
      payerId, claimedAmount,
      claimBillDetails: !isEmpty(readyBillDetail) ? readyBillDetail : billPackageNameMulti,
      payerClaimExtensionFields: payerExtension,
      attachments: prepareAttachment(attachments, documentTypeLookUp),
      providerId: appDetail?.getProviderId(),
      insurerName: (insurerName || insurerNameText) ?
        getLookUpFullDetail([insurerName || insurerNameText], insurerNameLookUp, true) :
        undefined,
      roomType: finalRoomType,
      hospitalRoomType: finalHospitalRoomType,
      procedureType: findProcedureType(),
      procedureDesc: (!autoProcedureArr?.length ? getLookUpFullDetail(procedure[0] ? procedure : procedureMulti,
        checkIsLazyLoadingMaster('Procedure', lazyLoadMasterTypes) ? procedureDynamicLookup : procedureLookUp, true) : undefined),
      ProcdureDescAutomation: autoProcedureArr?.length > 0 ? autoProcedureArr : undefined,

      diagnosis: !isEmpty(finalDiagnosis) ? finalDiagnosis : undefined,
      classifications: prepareClassifications(classificationArray, attachments),
      schemeType: productCode,
      remarks: (isDischargeContestCTA && finalRemark) ? `Discharge Contest: ${finalRemark || ''}` : finalRemark,
      phraddress: phrAddress ? phrAddress[0] : undefined,
      gender,
      healthId: isNHCXClaimFlow ? healthId : healthIdAddr,
      abhaAddress,
      token,
      billAmountArray,
      draftId: selectedDraft?.draftId || 0,
      attendantContactNumber,
      panCardNumber,
      integrationSystemPateintDetails: !isEmpty(selectedPatientDetail) ?
        selectedPatientDetail : undefined, // sending selected HIS detail only incase of selection of HIS
      isHISClaim,
    };
    yield put(setDOA(requestPayload?.doa));
    yield put(setSinceYearDate(null));
    yield claimActionService(requestPayload, onSuccess, onError, healthId, { isOnMailPayer, isCorporatePayer, isRPAOutboundDisabledPayer });
  } catch (e) {
    console.error(e);
    onError(e || COMMON_ERROR);
  }
}

function* downloadClaimPDFsaga({ payload }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}/Provider/Claim/PrefilledPreauthForm`;
    const sentOtpResponse: any = yield sendRequest.post(url, payload, {
      isShowErrorInInterceptor: false,
    });
    const { isSuccess = false, fileByte = [], errorMessage = '', fileByName = [] } = sentOtpResponse || {};
    if (isSuccess) {
      for (let i = 0; i < fileByte.length; i++) {
        const fileByteResponse = fileByte[i];
        const linkSource = 'data:' + 'application/pdf' + ';base64,' + fileByteResponse;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        if (fileByte.length > 1 && i === 1) {
          downloadLink.download = `${fileByName?.[1]}.pdf`;
        } else {
          downloadLink.download = `${fileByName?.[0]}.pdf`;
        }
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
      const successMessage =
        payload.formType === 'cashlessForm'
          ? CASHLESS_PDF_DOWNLOAD_SUCCESS_MESSAGE
          : payload.formType === 'checklistForm' ? CHECKLIST_PDF_DOWNLOAD_SUCCESS_MESSAGE
            : ACKNOWLEDGEMENT_PDF_DOWNLOAD_SUCCESS_MESSAGE;
      centeredNotification(successMessage, 'success');
    } else {
      centeredNotification(errorMessage, 'error');
    }
  } catch (e) {
    console.error(e);
  }
}
function* printClaimPDFsaga({ payload, onCallback }: any): Generator {
  const getPDFViewer = onCallback;
  const sendRequest = SendRequest.instance;
  const { downloadDocumentGuidList }: any = yield select((state: RootState): NewAdmissionState => state.newAdmission);
  payload = {
    attachGuids: downloadDocumentGuidList,
  };
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}/Provider/File/DownloadPdf`;
    const response: any = yield sendRequest.post(url, payload, {
      isShowErrorInInterceptor: false,
    });
    const { isSuccess, errorMessage } = response || {};

    if (isSuccess) {
      getPDFViewer(response);
    } else {
      centeredNotification(errorMessage, 'error');
    }
  } catch (e) {
    console.error(e);
  }
}

function* hisPrintClaimPDFsaga({ payload, onCallback }: any): Generator {
  const getPDFViewer = onCallback;
  const sendRequest = SendRequest.instance;
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/File/Download`;
  const downloadData: any = yield sendRequest.post(url, { attachGuids: payload?.fileGuid, guid: payload?.guid });
  const { isSuccess, errorMessage } = downloadData;
  if (isSuccess) {
    getPDFViewer(downloadData);

  } else {
    centeredNotification(errorMessage, 'error');
  }
}

function* claimActionService(requestPayload: any, onSuccess: () => {}, onError: any, healthId: any = null,
  additionalParams?: IClaimActionAdditionalParams): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const { isOnMailPayer, isCorporatePayer, isRPAOutboundDisabledPayer } = additionalParams || {};
    const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Claim/${(!isOnMailPayer && !isCorporatePayer && !isRPAOutboundDisabledPayer) ? 'ClaimAction' : 'ClaimActionOther'}`;
    // for replacing the empty string key
    replaceEmptyStringWithUndefined(requestPayload);
    const newAdmissionResponse: any = yield sendRequest.post(url, requestPayload, {
      isShowErrorInInterceptor: false,
    });
    const { isSuccess = false, errors = [], hipOnConfirmResponseDTO = null, hospActionId, ErrorMessage } = newAdmissionResponse || {};
    if (isSuccess) {
      yield put(setHospActionId(hospActionId));
      const confirmationMessage = healthId ?
        hipOnConfirmResponseDTO !== null ? 'ABHA health record is linked.' : 'Demographic Data Mismatch. Unable to link patient record.' : 'ABHA health record is not linked because health id is not provided.';
      yield put(setHidConfirmationMessage(confirmationMessage));
      onSuccess();
    } else {
      onError(errors.join(', ') || ErrorMessage);
    }
  } catch ({ response: { data } }: any) {
    const { errors, errorMessage }: any = data || {};
    if (errors instanceof Array) {
      onError(errors?.join(', ') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* submitIr({ form, onSuccess, onError }: any): Generator {
  try {
    const {
      admissionDetails: { claimDetails: {
        payerClaimNo = '', hospActionId = '', nextAllowStatus = [], payerActualId: payerId = '',
        isNHCXClaimFlow = false,
        isArtemis = false,
      } = {} } = {},
      newAdmission: { uploadedFiles = [], classificationArray: classifications = [], defaultTimeline = {},
        additionalAdmissionInfo = {}, selectedDraft = [] } = {},
      payerList: { payer = {}, formControlConfig },
      mailBox: { hospitalConfiguration } = {} as any,
    }: any = yield select((state: RootState): any => state);
    const { additionalEmails } = form.getFieldsValue(['additionalEmails']);
    const trimmedEmails = trimEmails(additionalEmails);
    const attachments = uploadedFiles.filter(({ existingRecord }: any): boolean => !existingRecord);
    const { isOnMailPayer, isCorporatePayer, isDirectPayer, isRPAOutboundDisabledPayer } = payer;
    const { remarks } = defaultTimeline || {};
    const isOrionIntegrationEnabledProvider = ApplicationDetail.instance.getIsOrionIntegrationEnabled();
    const payerConfigValues = Object.values(formControlConfig);
    const isArtemisPayer = payerConfigValues?.some(({ type }: any): boolean => type === 'ARTEMIS') || false;
    const isOrionIntegrationEnabledPayerProvider = isOrionIntegrationEnabledProvider && isArtemisPayer;
    if (hospitalConfiguration?.passwordExpire && (isOnMailPayer || isCorporatePayer)) {
      return onError('PASSWORD_EXPIRED');
    }
    let finalRemark;
    if (!checkEmptyObj(remarks)) {
      finalRemark = Object.values(remarks || {}).filter((msg: any): boolean => msg).join(', ');
    }

    const payerExtension = prepareExtension({
      remarks, additionalEmails: trimmedEmails, additionalAdmissionInfo, action: nextAllowStatus[0],
      isNHCXClaimFlow,
      isDirectPayer : isDirectPayer ? isDirectPayer : undefined, isArtemis : isArtemis ? isArtemis : undefined,
      payerProductCode : getProductCode(isOrionIntegrationEnabledPayerProvider, isArtemis),
    });

    const requestPayload = {
      action: nextAllowStatus[0], hospActionId, payerClaimNo, payerId,
      attachments: prepareAttachment(attachments),
      classifications,
      payerClaimExtensionFields: payerExtension,
      remarks: finalRemark,
      draftId: selectedDraft?.draftId,
    };
    yield claimActionService(requestPayload, onSuccess, onError, null, { isOnMailPayer, isCorporatePayer, isRPAOutboundDisabledPayer });
  } catch (e) {
    onError(COMMON_ERROR);
  }
}

export function* submitSettlement({ form, onSuccess, onError }: any): Generator {
  try {
    const {
      inPatientNumber: ipNumber,
      patientPaidAmount,
      recieptNo,
      includeOldDocuments,
      isDocChecklistVerified,
      courierTrackId,
      courierProvider,
      courierReceiptNumber,
      otherCourierProvider,
      switchClick,
      additionalEmails,
      selectedOldFile,
      branch,
      courierName,
      consignmentNumber,
      dispatchDate,
      documentType,
      noOfFiles,
      aadharNo,
      panNumber,
      settlementPan,
      typeOfClaim,
      claimedAmount,
      documentSubmissionType,
      handedOverTo, podNo, dateOfDelivery,
      dateOfDispatch, courierAgencyName,
      doctorName, doctorQualification,
    } = form.getFieldsValue(['inPatientNumber', 'recieptNo', 'patientPaidAmount', 'includeOldDocuments', 'isDocChecklistVerified', 'courierTrackId', 'courierProvider', 'courierReceiptNumber', 'otherCourierProvider', 'switchClick', 'additionalEmails',
      'selectedOldFile', 'branch', 'courierName', 'consignmentNumber', 'dispatchDate', 'documentType', 'noOfFiles', 'aadharNo', 'panNumber', 'typeOfClaim', 'claimedAmount', 'documentSubmissionType', 'handedOverTo', 'podNo', 'dateOfDelivery',
      'dateOfDispatch', 'courierAgencyName', 'doctorName', 'doctorQualification', 'settlementPan' ]);
    const {
      admissionDetails: { claimDetails: {
        payerClaimNo = '', hospActionId = '', nextAllowStatus = [], payerActualId: payerId = '', claimFlowData = [],
        doa = moment(), dod = moment(), isNHCXClaimFlow = false, isArtemis = false,
      } = {} } = {},
      newAdmission: { uploadedFiles = [], classificationArray: classifications = [], billAmountArray = [], defaultTimeline = {},
        additionalAdmissionInfo = {}, selectedDraft = [], panCardNumber = '' } = {},
      payerList: { payer = {}, formControlConfig },
      mailBox: { hospitalConfiguration } = {} as any,
    }: any = yield select((state: RootState): any => state);
    const { remarks } = defaultTimeline || {};
    const { isOnMailPayer, isCorporatePayer, isDirectPayer, isRPAOutboundDisabledPayer } = payer;
    const payerConfigValues = Object.values(formControlConfig);
    const isArtemisPayer = payerConfigValues?.some(({ type }: any): boolean => type === 'ARTEMIS') || false;
    const isOrionIntegrationEnabledProvider = ApplicationDetail.instance.getIsOrionIntegrationEnabled();
    const isOrionIntegrationEnabledPayerProvider = isOrionIntegrationEnabledProvider && isArtemisPayer;
    let attachments = uploadedFiles.filter(({ existingRecord }: any): boolean => includeOldDocuments ? true : !existingRecord);
    attachments = selectedOldFile?.length > 0 ? [...attachments, ...alreadyUploadedDocs(claimFlowData)?.filter((file: any): any => {
      return selectedOldFile?.flatMap((f: any): any => f.uid).includes(file.uid);
    })] : attachments;
    const trimmedEmails = trimEmails(additionalEmails);
    let finalRemark;
    if (hospitalConfiguration?.passwordExpire && (isOnMailPayer || isCorporatePayer)) {
      return onError('PASSWORD_EXPIRED');
    }
    if (!checkEmptyObj(remarks)) {
      finalRemark = Object.values(remarks || {}).filter((msg: any): boolean => msg).join(', ');
    }

    const payerExtension = prepareExtension({
      remarks, courierTrackId: courierReceiptNumber || courierTrackId, courierProvider: otherCourierProvider || courierProvider,
      isDocChecklistVerified, additionalEmails: trimmedEmails, documentType, noOfFiles,
      aadharNo, panNumber: settlementPan || panNumber, typeOfClaim,
      documentSubmissionType, additionalAdmissionInfo, action: nextAllowStatus[0], switchClick, panCardNumber, branch, courierName,
      consignmentNumber, dispatchDate, handedOverTo, podNo, dateOfDelivery, dateOfDispatch, courierAgencyName,
      isNHCXClaimFlow, isDirectPayer : isDirectPayer ? isDirectPayer : undefined,
      doctorQualification,
      isArtemis: isArtemis ? isArtemis : undefined,
      payerProductCode : getProductCode(isOrionIntegrationEnabledPayerProvider, isArtemis),
    });

    const requestPayload = {
      action: nextAllowStatus[0], hospActionId, payerClaimNo, payerId,
      attachments: prepareAttachment(attachments),
      classifications, ipNumber, receiptNo: recieptNo, billAmountArray,
      patientPaidAmount: patientPaidAmount ? parseInt(String(patientPaidAmount).replace(/[₹ ,]/g, ''), 10) : 0,
      doa: moment(doa)?.format(),
      dod: moment(dod)?.format(),
      payerClaimExtensionFields: payerExtension,
      remarks: finalRemark,
      draftId: selectedDraft?.draftId,
      claimedAmount: claimedAmount ? parseInt(String(claimedAmount).replace(/[₹ ,]/g, ''), 10) : 0,
      doctorName,
    };
    yield claimActionService(requestPayload, onSuccess, onError, null, { isOnMailPayer, isCorporatePayer, isRPAOutboundDisabledPayer });
  } catch (e) {
    onError(COMMON_ERROR);
  }
}
export function* submitSettlementCourierTrack({ form, onSuccess, onError }: any): Generator {
  yield submitSettlement({ form, onSuccess, onError });
}

function* submitCancel({ IsUserAccepted, onSuccess, onError }: any): Generator {
  try {
    const { hospActionId, payerClaimNo, isCancelable, payerActualId, reasonForCancellation }: any = yield select((state: RootState): any =>
      state?.admissionDetails?.claimDetails);
    const { uploadedFiles, defaultTimeline = {} }: any = yield select((state: RootState): NewAdmissionState => state?.newAdmission);
    const { isOnMailPayer, isCorporatePayer,
      isRPAOutboundDisabledPayer }: any = yield select((state: RootState): Payer => state?.payerList?.payer || {});
    const attachments = uploadedFiles.filter(({ existingRecord }: any): boolean => !existingRecord);
    const { mailBox: { hospitalConfiguration } = {} as any }: any = yield select((state: RootState): RootState => state || {});
    const { remarks } = defaultTimeline || {};
    let finalRemark;

    if (!checkEmptyObj(remarks)) {
      finalRemark = Object.values(remarks || {}).filter((msg: any): boolean => msg).join(', ');
    }
    if (hospitalConfiguration?.passwordExpire && (isOnMailPayer || isCorporatePayer)) {
      return onError('PASSWORD_EXPIRED');
    }
    let requestPayload: any = {
      hospActionId, payerClaimNo, payerId: payerActualId,
      payerClaimExtensionFields: prepareExtension({ IsUserAccepted, remarks, reasonForCancellation }),
      attachments: prepareAttachment(attachments, []),
      remarks: finalRemark,
    };

    const action = 'CANCEL';
    if (isCancelable) {
      requestPayload = {
        ...requestPayload,
        action,
      };
    }
    yield claimActionService(requestPayload, onSuccess, onError, null, { isOnMailPayer, isCorporatePayer, isRPAOutboundDisabledPayer });
  } catch (e) {
    onError(COMMON_ERROR);
  }
}

function* paymentAcknowledge({ payload, onSuccess, onError }: any): Generator {
  const { id: payerId }: any = yield select(
    (state: RootState): any => state?.payerList?.payer,
  );
  const { hospActionId, payerClaimNo, providerId, isNHCXClaimFlow }: any = payload;
  const extensionFields = prepareExtension({ isNHCXClaimFlow });
  const action = actions.ACKNOWLEDGEPAYMENT;
  const requestPayload = {
    hospActionId,
    payerClaimNo,
    providerId,
    action,
    payerId,
    payerClaimExtensionFields: extensionFields,
  };
  try {
    yield claimActionService(requestPayload, onSuccess, onError, null);
  } catch (e) {
    console.error(e);
  }
}

function* checkForDuplicateClaim({ payload }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Claim/CheckDuplicateClaim`;
    const newAdmissionResponse: any = yield sendRequest.post(url, payload, {
      isShowErrorInInterceptor: false,
    });
    const { isSuccess = false, errors = [], duplicateClaimDetails = {} } = newAdmissionResponse || {};
    if (isSuccess) {
      yield put(setExistingClaimError({ isError: false }));
    } else if (!isEmpty(duplicateClaimDetails)) {
      yield put(setExistingClaimError({ errorMessage: errors.join(', '), duplicateClaimDetails, isError: true }));
    }
  } catch (e) {
    console.error(e);
  }
}

function* fetchAbhaVerificationMethods({ payload }: any): Generator {
  const body = {
    'requestId': 'string',
    'timestamp': 'string',
    'query': {
      'id': payload,
      'purpose': 'string',
      'requester': {
        'type': 'string',
        'id': 'string',
      },
    },
  };

  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Health/Mobile/Aadhar/fetch-modes`;
    const verificationModesResponse: any = yield sendRequest.post(url, body, {
      isShowErrorInInterceptor: false,
    });
    const { error = {}, auth = {} } = verificationModesResponse || {};

    if (error && error.code) {
      centeredNotification(error.message, 'error');
      yield put(fetchAbhVerificationMethodsFailure(true));
    } else if (auth && Object.keys(auth).length > 0) {
      yield put(fetchAbhVerificationMethodsSuccess(auth));
    } else {
      centeredNotification(COMMON_ERROR, 'error');
      yield put(fetchAbhVerificationMethodsFailure(true));
    }
  } catch (error) {
    centeredNotification(COMMON_ERROR, 'error');
    yield put(fetchAbhVerificationMethodsFailure(true));
  }
}

function* abhaVerificationSentOtp({ payload }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Health/Mobile/Aadhar/Init`;
    const sentOtpResponse: any = yield sendRequest.post(url, payload, {
      isShowErrorInInterceptor: false,
    });
    const { isSuccess = false, txnId = '', errorMessage = '' } = sentOtpResponse || {};

    if (isSuccess && txnId?.length > 0) {
      yield put(abhaVerificationSentOtpSuccess(txnId));
    } else {
      centeredNotification(errorMessage, 'error');
      yield put(abhaVerificationSentOtpFaulire());
    }
  } catch (e) {
    console.error(e);
    yield put(abhaVerificationSentOtpFaulire());
  }
}

function* abhaConfirmOtp({ payload }: any): Generator {
  const { otp, txnId, selectedAbhaAuthMethod } = payload;

  const sendRequest = SendRequest.instance;
  try {
    const url =
      selectedAbhaAuthMethod === 'AADHAAR_OTP'
        ? `${GLOBAL_URL.CRM_BASE_URL}Health/Mobile/Aadhar/ConfirmWithAadharOTP`
        : `${GLOBAL_URL.CRM_BASE_URL}Health/Mobile/Aadhar/ConfirmWithMobileOTP`;

    const apiPayload = { otp, txnId };

    const sentOtpResponse: any = yield sendRequest.post(url, apiPayload, {
      isShowErrorInInterceptor: false,
    });
    const {
      isSuccess = false,
      token = '',
      healthId = '',
      errorMessage = '',
      healthIdNumber = '',
    } = sentOtpResponse || {};

    if (
      isSuccess && token && token.length > 0 &&
      healthIdNumber && healthIdNumber.length > 0
    ) {
      const data = {
        token, healthId, healthIdNumber,
      };
      yield put(abhaConfirmOtpSuccess(data));
      yield put(setIsAbhaVerified(true, data));
      success('Abha ID is verified successfully.');
    } else {
      centeredNotification(errorMessage, 'error');
      yield put(abhaConfirmOtpError());
    }
  } catch (error: any) {
    yield put(abhaConfirmOtpError());
    centeredNotification(error?.response?.data?.errorMessage, 'error');
  }
}

function* getOldClaimDetails({ payload: { selectedBenef, onSuccess } }: any): Generator {
  try {
    const { id: payerId, productCode }: any = yield select((state: RootState): Payer => state?.payerList?.payer || {});
    const { memberId, memberName, policyNo } = selectedBenef;
    const reqPayload = {
      memberId,
      memberName,
      policyNo,
      payerId,
      productCode,
    };
    const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/TreatmentClaimsDetails`;
    const { isSuccess, claimDetails }: any = yield SendRequest.instance.post(url, reqPayload);
    if (isSuccess) {
      onSuccess(claimDetails);
    } else {
      onSuccess();
    }
  } catch (e) {
    onSuccess();
  }
}
export function* generateVerificationOtp({ payload, onSuccess, onError }: any): Generator {
  yield adharVerificationOtp(payload, onSuccess, onError);
}
export function* adharVerificationOtp(payload: any, onSuccess: any, onError: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Common/DocumentVerify`;

    const generateOTP: any = yield sendRequest.post(url, payload, { isShowErrorInInterceptor: false });
    const { isSuccess = false, errors = [], reference_id = '' } = generateOTP || {};
    if (isSuccess) {
      onSuccess(reference_id);
    } else {
      onError(errors.join(','));
    }
  } catch (response: any) {
    const { errors, errorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* verifyAadharOtp({ payload, onSuccess, onError }: any): Generator {
  yield otpAadharVerification(payload, onSuccess, onError);
}
export function* otpAadharVerification(payload: any, onSuccess: any, onError: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Common/DocumentVerify`;

    const validateOTP: any = yield sendRequest.post(url, payload, { isShowErrorInInterceptor: false });
    const { isSuccess = false, errors = [], name } = validateOTP || {};
    if (isSuccess) {
      yield put(setAadhaarResponse(name));
      onSuccess();
    } else {
      onError(errors?.join(','));
    }
  } catch (response: any) {
    const { errors, errorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* panVerification({ payload, onSuccess, onError }: any): Generator {
  yield checkPanVerification(payload, onSuccess, onError);
}

export function* checkPanVerification(payload: any, onSuccess: any, onError: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Common/DocumentVerify`;

    const verifyPan: any = yield sendRequest.post(url, payload, { isShowErrorInInterceptor: false });
    const { isSuccess = false, errors = [], name } = verifyPan || {};
    if (isSuccess) {
      yield put(setAadhaarResponse(name));
      onSuccess();
    } else {
      onError(errors.join(','));
    }
  } catch (response: any) {
    const { errors, errorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* dlVerification({ payload, onSuccess, onError }: any): Generator {
  yield checkDlVerification(payload, onSuccess, onError);
}

export function* voterIdVerification({ payload, onSuccess, onError }: any): Generator {
  yield checkvoterIdVerification(payload, onSuccess, onError);
}

export function* checkDlVerification(payload: any, onSuccess: any, onError: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Common/DocumentVerify`;

    const verifyDob: any = yield sendRequest.post(url, payload, { isShowErrorInInterceptor: false });
    const { isSuccess = false, errors = [], name } = verifyDob || {};
    if (isSuccess) {
      yield put(setAadhaarResponse(name));
      onSuccess();
    } else {
      onError(errors.join(','));
    }
  } catch (response: any) {
    const { errors, errorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* checkvoterIdVerification(payload: any, onSuccess: any, onError: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Common/DocumentVerify`;

    const verifyVoterId: any = yield sendRequest.post(url, payload, { isShowErrorInInterceptor: false });
    const { isSuccess = false, errors = [], name } = verifyVoterId || {};
    if (isSuccess) {
      yield put(setAadhaarResponse(name));
      onSuccess();
    } else {
      onError(errors.join(','));
    }
  } catch (response: any) {
    const { errors, errorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* createHealthBankUser({ payload, onSuccess, onError }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.HEALTHLOCKER_URL}api/Auth/Register`;
    const createHealthbankUser: any = yield sendRequest.post(url, payload, { isShowErrorInInterceptor: false });
    const { isSuccess = false, errors = [], taU_Id } = createHealthbankUser || {};
    if (isSuccess) {
      yield put(setHealthBankUser(taU_Id ?? ''));
      onSuccess(taU_Id ?? '');
    } else {
      onError(errors.join(','));
    }
  } catch (response: any) {
    const { errors, errorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* fetchHealthBankUserProfileDetails({ newHealthBankUserId, onSuccess, onError }: any): Generator {

  const url = `${GLOBAL_URL.HEALTHLOCKER_URL}api/Profile/getprofile?userId=${newHealthBankUserId}`;
  try {
    const response: any = yield SendRequest.instance.get<any>(url);
    if (response?.length) {
      onSuccess(response);
    } else {
      onError();
    }
  } catch (e) {
    onError();
    console.error(e);
  }
}

// for the pre-existing-ticker file
export function* uploadTickerFile({ onSuccess, onError }: any): Generator {
  const sendRequest = SendRequest.instance;
  const isVersioningPostAPIEnabled = ApplicationDetail?.instance?.getIsVersioningPostAPIEnabled(); // Checking the flag
  try {
    const url = `${baseUrl}/Provider/GetAllProvidersTickerConfigurations`;
    let response: any;
    if (isVersioningPostAPIEnabled) {
      response = yield sendRequest.post(url, {});
    } else {
      response = yield sendRequest.get(url);
    }
    const { isSuccess = false, fileBytes, errorMessage, lastModifiedDate, overRideFrom, overRideTo, defaultConfiguration } = response || {};
    if (isSuccess) {
      onSuccess(fileBytes, lastModifiedDate, overRideFrom, overRideTo, defaultConfiguration);
    } else {
      onError(errorMessage);
    }
  } catch (response: any) {
    const { errors, errorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* fetchApplicationConfigurationSaga({ payload, onSuccess, onError }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}GetApplicationConfiguration`;
    const response: any = yield sendRequest.post(url, payload);
    const { isSuccess = false, result, errorMessage } = response || {};
    if (isSuccess) {
      onSuccess(result);
    } else {
      onError(errorMessage);
    }
  } catch (response: any) {
    const { errors, errorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* updateApplicationConfigurationSaga({ payload, onSuccess, onError }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}UpdateApplicationConfiguration`;
    const response: any = yield sendRequest.post(url, payload);
    const { isSuccess = false, errorMessage } = response || {};
    if (isSuccess) {
      onSuccess('Updated successfully');
    } else {
      onError(errorMessage);
    }
  } catch (response: any) {
    const { errors, errorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* mergeDeMergeClaimsSaga({ payload, onSuccess, onError }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Claim/${payload?.action === 'merge' ? `MergeDuplicates` : `DeMergeClaims`}`;
    const response: any = yield sendRequest.post(url, payload);
    const { isSuccess = false, errorMessage } = response || {};
    if (isSuccess) {
      onSuccess(payload?.action === 'merge' ? 'Merged successfully' : 'De-merged successfully');
    } else {
      onError(errorMessage);
    }
  } catch (response: any) {
    const { errors, errorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || errorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* sendingTickerConfiguration({ payload, onSuccess, onError }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}/Provider/SaveProviderTickerConfiguration`;
    const response: any = yield sendRequest.postFormData(url, payload);

    const { isSuccess = false, ErrorMessage, errors, message } = response || {};
    if (isSuccess) {
      onSuccess(message);
    } else {
      onError(errors?.join(',') || ErrorMessage);
    }
  } catch (response: any) {
    const { errors, ErrorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || ErrorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

// api call for his file selection
export function* fetchHisFileGuid({ payload, onSuccess, onError }: any): any {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Common/GetPatientDocuGuid`;

    const response: any = yield sendRequest.post(url, payload, { isShowErrorInInterceptor: false });
    const { isSuccess, errorMessage, errors } = response || {};
    if (response) {
      if (isSuccess) {
        onSuccess(response);
      } else {
        centeredNotification(errorMessage || errors);
        onError(errorMessage || errors);
      }
  }
  } catch (e) {
    console.error(e);
  }
}

export function* watchNewAdmission(): any {
  yield takeEvery(actionTypes.BENEF_SEARCH, beneficiarySearch);
  yield takeEvery(actionTypes.HIS_BENEF_SEARCH, beneficiarySearchForHIS);
  yield takeEvery(actionTypes.SUBMIT_ADMISSION, submitAdmission);
  yield takeEvery(actionTypes.PAYMENT_ACKNOWLEDGE, paymentAcknowledge);
  yield takeEvery(actionTypes.DOWNLOAD_CLAIM_PDF, downloadClaimPDFsaga);
  yield takeEvery(actionTypes.PRINT_CLAIM_PDF, printClaimPDFsaga);
  yield takeEvery(actionTypes.HIS_PRINT_CLAIM_PDF, hisPrintClaimPDFsaga);
  yield takeEvery(actionTypes.SUBMIT_IR, submitIr);
  yield takeEvery(actionTypes.CANCEL_CLAIM, submitCancel);
  yield takeEvery(actionTypes.SUBMIT_SETTLEMENT, submitSettlement);
  yield takeEvery(actionTypes.SUBMIT_SETTLEMENT_COURIER, submitSettlementCourierTrack);
  yield takeEvery(actionTypes.CHECK_DUPLICATE_CLAIM, checkForDuplicateClaim);
  yield takeEvery(actionTypes.FETCH_ABHA_VERIFICATION_METHODS, fetchAbhaVerificationMethods);
  yield takeEvery(actionTypes.ABHA_VERIFICATION_SENT_OTP, abhaVerificationSentOtp);
  yield takeEvery(actionTypes.ABHA_CONFIRM_OTP, abhaConfirmOtp);
  yield takeEvery(actionTypes.GET_OLD_CLAIM_DETAIL, getOldClaimDetails);
  yield takeEvery(actionTypes.GET_AADHAR_OTP, generateVerificationOtp);
  yield takeEvery(actionTypes.VERIFY_AADHAR_OTP, verifyAadharOtp);
  yield takeEvery(actionTypes.PAN_VERIFICATION, panVerification);
  yield takeEvery(actionTypes.CREATE_HEALTHBANK_USER, createHealthBankUser);
  yield takeEvery(actionTypes.FETCH_HEALTHBANK_USER_PROFILE_DETAILS, fetchHealthBankUserProfileDetails);
  yield takeEvery(actionTypes.DRIVING_LICENSE_VERIFICATION, dlVerification);
  yield takeEvery(actionTypes.VOTER_ID_VERIFICATION, voterIdVerification);
  yield takeEvery(actionTypes.UPLOAD_TICKER_CONFIGURATOR, uploadTickerFile);
  yield takeEvery(actionTypes.SAVE_TICKER_DATA, sendingTickerConfiguration);
  yield takeEvery(actionTypes.GET_APPLICATION_CONFIGURATION, fetchApplicationConfigurationSaga);
  yield takeEvery(actionTypes.UPDATE_APPLICATION_CONFIGURATION, updateApplicationConfigurationSaga);
  yield takeEvery(actionTypes.SUBMIT_HIS_FILE, fetchHisFileGuid);
  yield takeEvery(actionTypes.MERGE_DEMERGE_CLAIMS, mergeDeMergeClaimsSaga);
}
export default watchNewAdmission;
